import loadable from '@loadable/component';

import LoadingPage from '../../components/LoadingPage';

const LoadableAppealResponsesPage = loadable(() => import('./index'), {
  fallback: LoadingPage,
});

export default LoadableAppealResponsesPage;
